import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const empty = { bank_name: "", nickname: "", account_last4: "", routing_number: "" };

export default function LinkExternalForm({ onLinked }) {
  const [f, setF] = useState(empty);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/external-accounts", f); toast.success("External account linked"); setF(empty); onLinked(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <form onSubmit={submit} className="tile" data-testid="link-external-form">
      <div className="p-6 grid sm:grid-cols-2 gap-3">
        <h3 className="sm:col-span-2 font-display font-semibold text-[var(--navy)]">Link an external account</h3>
        <Input placeholder="Bank name" value={f.bank_name} onChange={set("bank_name")} required data-testid="link-bank-name-input" />
        <Input placeholder="Nickname" value={f.nickname} onChange={set("nickname")} required data-testid="link-nickname-input" />
        <Input placeholder="Routing number (9 digits)" value={f.routing_number} onChange={set("routing_number")} required data-testid="link-routing-input" />
        <Input placeholder="Account last 4" value={f.account_last4} onChange={set("account_last4")} required data-testid="link-last4-input" />
        <Button variant="outline" className="sm:col-span-2 rounded-full" data-testid="link-submit-button">Link account</Button>
      </div>
    </form>
  );
}
